import { useConfigContext } from "@/state/configContext";
import { router } from "@/main";
import { useAdminContext } from "@/state/adminContext";
import { POST } from "@/state/server";
import type { AdminPedido } from "@/state/types";
import { useEffect, useRef, useState } from "react";
import { PedidoSelectProducto } from "./PedidoResumen";

export function AdminPedidoResumen({ pedido }: { pedido: AdminPedido }) {
  const config = useConfigContext();
  const { admin } = useAdminContext();
  const [descuento, setDescuento] = useState(pedido.descuento);

  useEffect(() => setDescuento(pedido.descuento), [pedido.descuento]);

  const [obs, setObs] = useState(pedido.obs ?? "");

  const subtotal = pedido.subtotal;
  const total = subtotal - descuento;

  return (
    <div>
      <EditorCliente pedido={pedido} />
      {pedido.pagado &&
        (pedido.notificacion ? (
          <button
            className="btn btn-default btn-login"
            onClick={() => POST(`/admin/pedido/renotificar/${pedido.id}`)}
          >
            Renotificar
          </button>
        ) : (
          "Notificacion pendiente"
        ))}

      {pedido.pagado || (
        <>
          <PedidoSelectProducto pedido={pedido} pref="/admin" />

          <h4>Mi compra</h4>

          <h5>
            Subtotal: {subtotal} {config.moneda}
            <br />
            Descuento:{" "}
            <input
              value={descuento}
              onChange={(e) => setDescuento(Number(e.target.value) || 0)}
              size={6}
            />{" "}
            {config.moneda}
            <br />
            Total: {total} {config.moneda}
          </h5>
        </>
      )}

      <h4>Observaciones</h4>
      <div>
        <textarea value={obs} onChange={(e) => setObs(e.target.value)} />
      </div>
      {pedido.pagado && (
        <button
          className="btn btn-default btn-login"
          onClick={() =>
            POST("/admin/pedido/set_obs", { pedido_id: pedido.id, obs })
          }
        >
          Corregir observaciones
        </button>
      )}

      {pedido.pagado ||
        (total >= 0 ? (
          <>
            <h4>Forma de pago</h4>
            {admin.cuentas
              ?.filter((c) => c.recibe_pagos_local)
              .map((c) => (
                <button
                  key={c.id}
                  className="btn btn-default btn-login"
                  onClick={async () => {
                    const res = await POST("/admin/pedido/pagado", {
                      pedido_id: pedido.id,
                      descuento,
                      obs,
                      cuenta_id: c.id,
                      moneda: config.moneda,
                    });
                    if ("pantalla" in res) {
                      router.navigate({
                        to: "/admin/pedidos/cerrados",
                        replace: true,
                      });
                    }
                  }}
                >
                  {c.nombre}
                </button>
              ))}
          </>
        ) : (
          "DESCUENTO INVALIDO"
        ))}
    </div>
  );
}

function EditorCliente({ pedido }: { pedido: AdminPedido }) {
  const nombre = useRef<HTMLInputElement>(null),
    email = useRef<HTMLInputElement>(null),
    pass = useRef<HTMLInputElement>(null);

  return (
    <>
      <h4>Cliente</h4>
      <p>
        <input defaultValue={pedido.cliente.nombre} ref={nombre} />
      </p>
      <p>
        <input defaultValue={pedido.cliente.email} ref={email} />
      </p>
      <p>
        <input type="password" ref={pass} />
      </p>
      <div>
        <button
          className="btn btn-default btn-login"
          onClick={() =>
            POST(`/admin/pedido/cliente`, {
              pedido_id: pedido.id,
              nombre: nombre.current?.value,
              email: email.current?.value,
              password: pass.current?.value,
            })
          }
        >
          Corregir datos
        </button>{" "}
        <button
          className="btn btn-default btn-login"
          onClick={() =>
            POST(`/admin/pedido/nuevo_cliente`, {
              pedido_id: pedido.id,
              nombre: nombre.current?.value,
              email: email.current?.value,
              password: pass.current?.value,
            })
          }
        >
          Cambiar de cliente
        </button>
      </div>
    </>
  );
}
